// extracted by mini-css-extract-plugin
export default {"container":"Mode_container__xSpY7","desc":"Mode_desc__W1Vqm"};